import * as types from './mutationTypes';

export const setMapLoadedState = ({ commit }, payload) => {
  commit(types.SET_MAP_LOADED_STATE, payload);
};

export default {
  setMapLoadedState,
};
